import React from 'react';

import { AvatarProps, BadgeProps, Avatar as MUIAvatar } from '@mui/material';

import StyledAvatarBadge from './styled';

interface CustomAvatarProps extends AvatarProps {
	badgeContent?: React.ReactNode;
	badgeProps?: Omit<BadgeProps, 'children'>;
	size?: number;
}

function Avatar({ badgeContent, badgeProps, size = 48, sx, ...avatarProps }: CustomAvatarProps) {
	if (!badgeContent) {
		return <MUIAvatar sx={{ width: size, height: size, ...(sx && { sx }) }} {...avatarProps} />;
	}

	const { color: badgeColor = 'primary' } = badgeProps;
	return (
		<StyledAvatarBadge
			overlap="circular"
			badgeContent={badgeContent}
			color={badgeColor}
			{...badgeProps}
		>
			<MUIAvatar sx={{ width: size, height: size, ...(sx && { sx }) }} {...avatarProps} />
		</StyledAvatarBadge>
	);
}

export default React.memo(Avatar);
